module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    staticClass: "no-swipeback",
    attrs: {
      "login-screen": "",
      "id": "login"
    },
    on: {
      "page:reinit": function($event) {}
    }
  }, [_c('div', {
    staticClass: "body hideScrollbar"
  }, [(_vm.isLargeScreen) ? _c('div', [_c('f7-navbar', [_c('f7-nav-left'), _vm._v(" "), _c('f7-nav-center', {
    staticClass: "titleApp",
    attrs: {
      "sliding": ""
    }
  }, [_c('div', {
    staticClass: "logo-browser"
  }, [_c('p', {
    staticClass: "logoHomepage"
  }, [_c('img', {
    staticClass: "logoBigScreen",
    attrs: {
      "src": require("./../../assets/static/images/logo/moneyroad_green.svg")
    }
  })])])]), _vm._v(" "), _c('f7-nav-right')], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row registerForm"
  }, [_c('div', {
    staticClass: "col-lg-4 offset-lg-4"
  }, [_c('div', {
    staticClass: "panel21 panel-default loginPanel loginHeight"
  }, [_c('p', {
    staticClass: "displayimg col-sm showSmallScreenOnly"
  }, [_c('img', {
    staticClass: "logoSmallScreen",
    attrs: {
      "src": require("./../../assets/static/images/MoneyRoadLogo3.png")
    }
  })]), _c('div', {
    staticClass: "panel-heading ajust col-md-10 offset-md-1"
  }, [(!_vm.activationCode) ? _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.$t('loginPage.sign_in_activated')))]) : _vm._e(), _vm._v(" "), (_vm.activationCode) ? _c('h3', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.$t('loginPage.sign_in_not_activated')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.QuickLogin()
      }
    }
  }, [_c('f7-list', {
    staticClass: "loginForm",
    attrs: {
      "form": ""
    }
  }, [_c('f7-list-item', {
    staticClass: "loginListhideBorder col-md-12"
  }, [_c('f7-input', {
    staticClass: "userInput",
    attrs: {
      "name": "username",
      "placeholder": _vm.loginpage_Identifier,
      "type": "email",
      "title": _vm.loginpage_UnvalidEmail
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return $event.target.blur()
      }
    },
    model: {
      value: (_vm.credentials.Login),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "Login", $$v)
      },
      expression: "credentials.Login"
    }
  })], 1), _vm._v(" "), _c('f7-list-item', {
    staticClass: "loginListhideBorder col-md-12"
  }, [_c('f7-input', {
    staticClass: "userInput",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": _vm.loginpage_Password
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return $event.target.blur()
      }
    },
    model: {
      value: (_vm.credentials.Password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "Password", $$v)
      },
      expression: "credentials.Password"
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-eye_blind icon icon-password",
    staticStyle: {
      "right": "0px",
      "position": "absolute"
    },
    on: {
      "click": _vm.toggleVisibility
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('f7-list', {
    staticClass: "loginButtons col-sm-4"
  }, [_c('f7-list-button', {
    staticClass: "logButton loginButton",
    attrs: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.authUser()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('loginPage.lgn')) + "\n                ")]), _vm._v(" "), _c('f7-list-button', {
    staticClass: "logButton loginButton",
    attrs: {
      "color": "white"
    },
    on: {
      "click": _vm.handleClickSignIn
    }
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('loginPage.login_ggl')) + "\n                ")]), _vm._v(" "), _c('f7-list-button', {
    staticClass: "logButton loginButton",
    attrs: {
      "link": "/register/",
      "color": "white"
    }
  }, [_c('i', {
    staticClass: "icon-edit_white icon icon-float-sub-button"
  }), _vm._v("\n                  " + _vm._s(_vm.$t('common.rgstr')) + "\n                ")])], 1), _vm._v(" "), _c('cm-account-activation-popup', {
    attrs: {
      "credentials": _vm.credentials
    }
  })], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-057797ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-057797ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/CMLogin.vue
// module id = 1611
// module chunks = 2